import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PrimeiroAcessoComponent } from './primeiro-acesso.component';

@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: PrimeiroAcessoComponent }
    ])],
    exports: [RouterModule]
})
export class PrimeiroAcessoRoutingModule { }